export const latestStories = [{
        id: 1,
        title: "बीजेपी संगठन में बड़ा फैसला",
        image: "https://www.livemint.com/lm-img/img/2024/05/05/600x338/ANI-20240505197-0_1714916040527_1714916093878.jpg",
        link: "https://thesootr.com/",
    },
    {
        id: 2,
        title: "MP में मौसम बदला, ठंड बढ़ी",
        image: "https://feeds.abplive.com/onecms/images/uploaded-images/2025/01/12/0ad8b9e1973885733fea54e948448a731736659296528694_original.jpg?impolicy=abp_cdn&imwidth=320",
        link: "https://thesootr.com/",
    },
    {
        id: 3,
        title: "CBSE Exam Pattern में बदलाव",
        image: "https://images.bhaskarassets.com/web2images/521/2025/12/10/for-only-1-line-cover-2025-12-10t122647767_1765349809.png",
        link: "https://thesootr.com/",
    },
    {
        id: 4,
        title: "इंदौर वोटिंग न्यूज़",
        image: "https://i.ytimg.com/vi/AWy10CNoxHY/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLBtAYTdd09BdVjgYm_TdNUVk26Iuw",
        link: "https://thesootr.com/",
    },
];
export const sidebarAd = {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xp-4dYvIGp3vg0DTPD1BKvhMjrg28TVrpg&s",
    link: "https://example.com",
    alt: "प्रायोजित विज्ञापन",
};